import axios from 'axios';
import { getApiUrl, parseMgkResponse } from '@/config/api';

const BASE = '/api/CatBanco';

export default {
  async listar(filtro = {}) {
    const response = await axios.post(getApiUrl(`${BASE}/listar`), filtro);
    const data = response.data;
    return Array.isArray(data) ? data : (data?.OData || []);
  },

  async guardar(model) {
    const response = await axios.post(getApiUrl(`${BASE}/guardar`), model);
    return parseMgkResponse(response);
  },

  async borrar(model) {
    const response = await axios.post(getApiUrl(`${BASE}/borrar`), model);
    return parseMgkResponse(response);
  },

  async sincronizarErp() {
    const response = await axios.post(getApiUrl(`${BASE}/sincronizar-erp`));
    return response.data;
  }
};
